module.exports = __webpack_public_path__ + "static/PP3-b87073cffaae2266bf164e4708c966d2.jpg";